import type { DependencyList, SyntheticEvent} from 'react';
import { useCallback, useRef } from 'react';

export function useAsyncBlockingEventHandler<E extends SyntheticEvent>(
    eventHandler: (event: E) => Promise<void>,
    deps: DependencyList,
): (event: E) => Promise<void> {
    const blocked = useRef(false);
    return useCallback(async (e) => {
        if (blocked.current) {
            e.preventDefault();
            return;
        }
        try {
            blocked.current = true;
            await eventHandler(e);
        } finally {
            blocked.current = false;
        }
    }, deps);
}
